import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class TechnicalDocumentationService {

  private techDocAllUrl = 'tech-doc/all';
  private techDocNewUrl = 'tech-doc/new';

  constructor(private http: HttpClient) { }

  // get all tech docs
  getTechDocsAll() {
    return this.http.get(this.techDocAllUrl,{withCredentials : true});
  }
  getTechDocsAllForAdmin(makeName) {
    return this.http.get(this.techDocAllUrl + '/makeName/' + makeName, {withCredentials : true});
  }
  getTechDocsAllForAdminActive(makeName) {
    return this.http.get(this.techDocAllUrl + '/techDocs/makeName/' + makeName, {withCredentials : true});
  }

  // get new tech docs
  getTechDocsNew() {
    return this.http.get(this.techDocNewUrl,{withCredentials : true});
  }

  // get user tech docs history
  getUserTechDocHistory(userId) {
    return this.http.get(`user-info/qID/${userId}/techDocHistorylist`,{withCredentials : true});
  }

  // save user visited document to user's history
  postUserTechDocHistory(userId, techDoc) {
    return this.http.post(`user-info/qID/${userId}/addTechDocToHistorylist/${techDoc}`, '',{withCredentials : true});
  }

}
